import { render, staticRenderFns } from "./recode.vue?vue&type=template&id=4a88237d&scoped=true&"
import script from "./recode.vue?vue&type=script&lang=js&"
export * from "./recode.vue?vue&type=script&lang=js&"
import style0 from "./recode.vue?vue&type=style&index=0&id=4a88237d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88237d",
  null
  
)

export default component.exports